import { Component, Input, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

import { Events } from '@service/events.service';
import { RepositoriesService } from '@service/repositories.service';
import { Repository } from '@model/Repository';
import { Message } from '@model/Message';

@Component({
  selector: 'app-modal-delete-repository',
  templateUrl: './modal-delete-repository.component.html'
})
export class ModalDeleteRepositoryComponent implements OnInit {

  @Input() public repository: Repository = {} as Repository;

  submitted: boolean = false;
  form: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private repositoriesService: RepositoriesService,
    private fb: FormBuilder,
    private readonly toast: ToastrService,
    private readonly events: Events
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      password: ['', Validators.required]
    });
  }

  delete() {
    this.submitted = true;

    if (this.form.invalid) {
      return;
    }

    this.repositoriesService.delete({ id: this.repository.id, password: this.form.get('password').value })
      .subscribe(() => {
        this.events.broadcast('deleteRepository', this.repository.id);
        this.toast.success(Message.SUCCESS);
        this.activeModal.dismiss(this.repository.id);
      }, (e) => {
        this.submitted = false;
        this.errorHandler(e);
      });
  }

  private errorHandler(e: HttpErrorResponse) {
    for (const key in e.error.errors) {
      this.toast.error(e.error.errors[key]);
    }
  }
}
